<template>
    <div class="grid-row" :class="{ 'with-date': showDate, 'is-editing': isEditing }" @click="onPreorderClick">
        <template v-if="preorder.reservationDetails">
            <div class="grid-cell time-cell">
                <span v-if="showDate" class="preorder-date">
                    <i class="far fa-calendar"></i> {{ displayDate(preorder.preorderDateTime) }}
                </span>
                <span class="time-from">
                    <i class="fas fa-right"></i>{{ displayTime(preorder.reservationDetails.timeFrom) }}
                </span>
                <span class="time-to">
                    <i class="fas fa-left"></i>{{ displayTime(preorder.reservationDetails.timeTo) }}
                </span>
            </div>
            <div class="grid-cell name-cell">
                <div class="guest-name">{{ preorder.ordererName }}</div>
                <ReservationTablesList
                    v-if="preorder.reservationDetails?.tableAssignmentAvailable === true"
                    ref="reservationTablesList"
                    :isReadonly="preorder.reservationDetails?.canEditTableAssignments === false"
                    :orderId="preorder.orderId"
                    :reservationDetails="preorder.reservationDetails"
                    @reservationDetailsChanged="onReservationDetailsChanged"
                />
            </div>
            <div class="grid-cell guests-cell">
                {{ preorder.reservationDetails.seats }}
            </div>
        </template>
        <template v-else>
            <div class="grid-cell time-cell">
                <span v-if="showDate" class="preorder-date">
                    <i class="far fa-calendar"></i>{{ displayDate(preorder.preorderDateTime) }}
                </span>
                <span class="time-from">
                    <i class="fas fa-right"></i>{{ displayTime(preorder.preorderDateTime) }}
                </span>
            </div>
            <div class="grid-cell name-cell">
                <div class="guest-name">{{ preorder.ordererName }}</div>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
    import type { IReservationDetails } from "@/data/model/Order";
    import { DateTime } from "@/data/util/DateTime";
    import { computed, ref } from "vue";

    import ReservationTablesList from "./ReservationTablesList.vue";

    type PreorderListItem = {
        orderId: string;
        preorderDateTime: Date;
        ordererName: string;
        reservationDetails?: IReservationDetails;
    };

    const emit = defineEmits(["reservationDetailsChanged", "preorderClick"]);

    const props = defineProps<{
        preorder: PreorderListItem;
        showDate: boolean;
    }>();

    const reservationTablesList = ref<InstanceType<typeof ReservationTablesList> | null>(null);
    const isEditing = computed(() => reservationTablesList.value?.isEditing);

    function displayDate(date: Date): string {
        return DateTime.toDateString(date);
    }

    function displayTime(date: Date): string {
        return DateTime.toTimeString(date);
    }

    function onReservationDetailsChanged(newReservationDetails: IReservationDetails) {
        emit("reservationDetailsChanged", newReservationDetails);
    }

    function onPreorderClick() {
        if (isEditing.value) return;
        emit("preorderClick", props.preorder.orderId);
    }
</script>
